// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import i18n from "./lang";
import Vant, { Toast } from "vant";
import Barrage from "vue-barrage";
// import echarts from 'echarts';
import vueEsign from "vue-esign";
import socketApi from "./utils/socket"; //引入socket.js文件
Vue.prototype.socketApi = socketApi; //设为全局对象

import cal from "./utils/calculate";

// tool
import api from "./api";
import setHtmlFontSize from "./utils/rem";
import registerComponent from "./components";

// css
import "./styles/reset.scss";
import "vant/lib/index.css";
import "./styles/index.scss"; // global style
import "font-awesome/css/font-awesome.min.css";
router.beforeEach((to, from, next) => {
  // // chrome
  // document.body.scrollTop = 0
  // // firefox
  // document.documentElement.scrollTop = 0
  // // safari
  // window.pageYOffset = 0
  next();
});

// 客服
// import Udesk from './utils/udesk'
// Udesk.init()

// import { create, all } from 'mathjs'

// const mathjs = create(all)

// mathjs.config({
//   undefined,
//   number: 'BigNumber',
//   precision: 64
// })

// Vue.prototype.$math = mathjs

// 全局引入自定义模板组件 AppTmpl*
registerComponent(Vue);

// 设置rem
setHtmlFontSize();
Vue.prototype.cal = cal;
// UI settings
Toast.setDefaultOptions({ forbidClick: true });
Vue.use(Vant);

Vue.use(Barrage);

Vue.use(vueEsign);

Vue.prototype.$api = api;
// Vue.prototype.$echarts = echarts

// config
Vue.config.productionTip = true;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js